import { __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ReelsFill = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M4 9h5.5l-3-5h-1A1.5 1.5 0 0 0 4 5.5V9Zm11.5 0H11L8 4h4.5l3 5ZM17 9l-3-5h4.5A1.5 1.5 0 0 1 20 5.5V9h-3Z" }),
        React.createElement("path", { d: "M20 10H4v8.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V10Zm-9 2.236v3.528c0 .185.185.298.328.2l2.571-1.764a.248.248 0 0 0 0-.4l-2.571-1.764c-.143-.098-.328.015-.328.2Z", fillRule: "evenodd" })));
};
ReelsFill.displayName = 'ReelsFill';
export default ReelsFill;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ReelsFill.js.map